import React from 'react';
import {
  SiJavascript,
  SiJava,
  SiReact,
  SiHtml5,
  SiCss3,
  SiRedux,
  SiReactrouter,
  SiNodedotjs,
  SiExpress,
  SiSequelize,
  SiPostgresql,
  SiMysql,
} from 'react-icons/si';

const dataSkills = [
  {
    color: '#F7E018',
    name: 'JavaScript',
    icon: <SiJavascript />,
  },
  {
    color: '#01778F',
    name: 'Java',
    icon: <SiJava />,
  },
  {
    color: '#61DAFB',
    name: 'React',
    icon: <SiReact />,
  },
  {
    color: '#43853D',
    name: 'Node.js',
    icon: <SiNodedotjs />,
  },
  {
    color: '#F16524',
    name: 'HTML5',
    icon: <SiHtml5 />,
  },
  {
    color: '#2465F1',
    name: 'CSS3',
    icon: <SiCss3 />,
  },
  {
    color: '#764ABC',
    name: 'Redux',
    icon: <SiRedux />,
  },
  {
    color: '#121212',
    name: 'ReactRouter',
    icon: <SiReactrouter />,
  },
  {
    color: '#353535',
    name: 'Express',
    icon: <SiExpress />,
  },
  {
    color: '#52B0E7',
    name: 'Sequelize',
    icon: <SiSequelize />,
  },
  {
    color: '#336791',
    name: 'PostgreSQL',
    icon: <SiPostgresql />,
  },
  {
    color: '#F29111',
    name: 'MySQL',
    icon: <SiMysql />,
  },
];

export default dataSkills;
